
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/builds/void-zero/clients/mijn-epd/sentry.client.config.ts")
            }
          });